import * as actionTypes from "./actionTypes";
import * as types from "./types";

// POST Spoke

const initialStateSpoke: types.IPostSpokeState = {
  pending: false,
  spoke: null,
  error: null,
};

export const PostSpokeReducer = (
  state = initialStateSpoke,
  action: types.PostSpokeActions
) => {
  switch (action.type) {
    case actionTypes.POST_SPOKE_REQUEST:
      return {
        ...state,
        pending: true,
      };
    case actionTypes.POST_SPOKE_SUCCESS:
      return {
        ...state,
        pending: false,
        spoke: action.payload.spoke,
        error: null,
      };
    case actionTypes.POST_SPOKE_FAILURE:
      return {
        ...state,
        pending: false,
        spoke: null,
        error: action.payload.error,
      };
    default:
      return {
        ...state,
      };
  }
};

//Get Spoke List

const initSpokeState: types.FetchSpokeState = {
  pending: false,
  spokes: {} as types.ISpokeDetails[],
  error: null,
};

export const SpokesDetailsReducer = (
  state = initSpokeState,
  action: types.SpokesActions
) => {
  switch (action.type) {
    case actionTypes.FETCH_SPOKE_LIST_REQUEST:
      return {
        ...state,
        pending: true,
      };
    case actionTypes.FETCH_SPOKE_LIST_SUCCESS:
      return {
        ...state,
        pending: false,
        spokes: action.payload.spokes,
        error: null,
      };
    case actionTypes.FETCH_SPOKE_LIST_FAILURE:
      return {
        ...state,
        pending: false,
        spokes: {} as types.ISpokeDetails[],
        error: action.payload.error,
      };
    default:
      return {
        ...state,
      };
  }
};

//Get Spoke By Id
const initSpokeByIdState: types.FetchSpokebyIdState = {
  pending: false,
  spoke: {} as types.ISpokeDetails,
  error: null,
};

export const SpokesDetailsByIdReducer = (
  state = initSpokeByIdState,
  action: types.SpokesByIDActions
) => {
  switch (action.type) {
    case actionTypes.FETCH_SPOKE_BY_ID_REQUEST:
      return {
        ...state,
        pending: true,
      };
    case actionTypes.FETCH_SPOKE_BY_ID_SUCCESS:
      return {
        ...state,
        pending: false,
        spoke: action.payload.spoke,
        error: null,
      };
    case actionTypes.FETCH_SPOKE_BY_ID_FAILURE:
      return {
        ...state,
        pending: false,
        spokes: {} as types.ISpokeDetails,
        error: action.payload.error,
      };
    default:
      return {
        ...state,
      };
  }
};


// DELETE Source Details

const initDeleteSpokeState: types.IDeleteSpokeState = {
  pending: false,
  success: null,
  error: null,
};

export const DeleteSpokeReducer = (state = initDeleteSpokeState, action: types.DeleteSpokeActions) => {
  switch (action.type) {
      case actionTypes.DELETE_SPOKE_REQUEST:
          return {
              ...state,
              success: null,
              pending: true,
          };
      case actionTypes.DELETE_SPOKE_SUCCESS:
          return {
              ...state,
              pending: false,
              success: action.success,
              error: null,
          };
      case actionTypes.DELETE_SPOKE_FAILURE:
          return {
              ...state,
              pending: false,
              success: null,
              error: action.payload.error,
          };
      default:
          return {
              ...state,
          };
  }
};

//Get Spoke List

const initSpokeListState: types.FetchSpokeListState = {
  pending: false,
  spokesList: {} as types.ISpokeListDetails[],
  error: null,
};

export const SpokesListDetailsReducer = (
  state = initSpokeListState,
  action: types.SpokesListActions
) => {
  switch (action.type) {
    case actionTypes.FETCH_SPOKE_LIST_LOAD_REQUEST:
      return {
        ...state,
        pending: true,
      };
    case actionTypes.FETCH_SPOKE_LIST_LOAD_SUCCESS:
      return {
        ...state,
        pending: false,
        spokesList: action.payload.spokesList,
        error: null,
      };
    case actionTypes.FETCH_SPOKE_LIST_LOAD_FAILURE:
      return {
        ...state,
        pending: false,
        spokesList: {} as types.ISpokeListDetails[],
        error: action.payload.error,
      };
    default:
      return {
        ...state,
      };
  }
};

